"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StrategyManagerContract = void 0;
const viem_1 = require("viem");
const abis_1 = require("../abis");
class StrategyManagerContract {
    readOnlyContract;
    _publicClient;
    _walletClient;
    constructor(address, publicClient, walletClient) {
        this.readOnlyContract = (0, viem_1.getContract)({
            address: address,
            abi: abis_1.strategyManagerContractAbi,
            client: publicClient,
        });
        this._publicClient = publicClient;
        this._walletClient = walletClient;
    }
    get publicClient() {
        return this._publicClient;
    }
    get walletClient() {
        if (!this._walletClient) {
            throw Error('wallet client not set');
        }
        return this._walletClient;
    }
    setWalletClient(walletClient) {
        this._walletClient = walletClient;
    }
    async writeContract({ functionName, args, gas, value, }) {
        const { request } = await this.publicClient.simulateContract({
            address: this.readOnlyContract.address,
            abi: abis_1.strategyManagerContractAbi,
            functionName,
            args,
            account: this.walletClient.account,
        });
        return this.walletClient.writeContract({
            ...request,
            gas,
            value,
        });
    }
    // ------------------------------ Change ------------------------------
    async depositIntoStrategy(strategyAddress, amount, options) {
        return this.writeContract({
            functionName: 'depositIntoStrategy',
            args: [strategyAddress, amount],
            gas: options?.gas,
            value: options?.value,
        });
    }
    async queueWithdrawFromStrategy(strategyAddress, shares, options) {
        return this.writeContract({
            functionName: 'queueWithdrawFromStrategy',
            args: [strategyAddress, shares],
            gas: options?.gas,
            value: options?.value,
        });
    }
    async completeWithdrawFromStrategy(strategyAddress, requestIds, options) {
        return this.writeContract({
            functionName: 'completeWithdrawFromStrategy',
            args: [strategyAddress, requestIds],
            gas: options?.gas,
            value: options?.value,
        });
    }
    // ------------------------------ View ------------------------------
    async listStrategies() {
        const len = Number(await this.strategiesLen());
        let offset = 0;
        const limit = 200;
        const strategies = [];
        while (offset < len) {
            const _limit = offset + limit > len ? len % limit : limit;
            const _strategies = await this._listStrategies(BigInt(offset), BigInt(_limit));
            strategies.push(..._strategies);
            offset += _limit;
        }
        return strategies;
    }
    async _listStrategies(offset, limit) {
        const addresses = await this.readOnlyContract.read.listStrategies([
            offset,
            limit,
        ]);
        return addresses;
    }
    async strategiesLen() {
        const len = await this.readOnlyContract.read.strategiesLen([]);
        return len;
    }
    async minWithdrawDelay() {
        const delay = await this.readOnlyContract.read.minWithdrawDelay([]);
        return delay;
    }
}
exports.StrategyManagerContract = StrategyManagerContract;
//# sourceMappingURL=StrategyManagerContract.js.map